(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaWorkflowForm"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "mobxReact", "mobx", "ReactDOM", "ReactRouter", "History", "weaWorkflowForm"], factory);
	else if(typeof exports === 'object')
		exports["weaWorkflowForm"] = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaWorkflowForm"));
	else
		root["weaWorkflowForm"] = factory(root["React"], root["mobxReact"], root["mobx"], root["ReactDOM"], root["ReactRouter"], root["History"], root["weaWorkflowForm"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_188__, __WEBPACK_EXTERNAL_MODULE_725__, __WEBPACK_EXTERNAL_MODULE_727__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/workflow/static4form/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 724);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(37)(function () {
    return Object.defineProperty(__webpack_require__(91)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(141)(false);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O)
        if (key != IE_PROTO)
            has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i)
        if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
        }
    return result;
};


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number')
    __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(142);
module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el)
            while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value)
                    return true;
                // Array#indexOf ignores holes, Array#includes - not
            }
        else
            for (; length > index; index++)
                if (IS_INCLUDES || index in O) {
                    if (O[index] === el)
                        return IS_INCLUDES || index || 0;
                }
        return !IS_INCLUDES && -1;
    };
};


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154);
module.exports = __webpack_require__(13).Object.assign;


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(21);
$export($export.S + $export.F, 'Object', { assign: __webpack_require__(155) });


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(52);
var gOPS = __webpack_require__(97);
var pIE = __webpack_require__(64);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(74);
var $assign = Object.assign;
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(37)(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while (aLen > index) {
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key))
                T[key] = S[key];
        }
    }
    return T;
} : $assign;


/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_188__;

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
if (typeof __g == 'number')
    __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(13);
var ctx = __webpack_require__(36);
var hide = __webpack_require__(42);
var has = __webpack_require__(41);
var PROTOTYPE = 'prototype';
var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL)
        source = name;
    for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key))
            continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
            // bind timers to global for call from export context
            : IS_BIND && own ? ctx(out, global)
                // wrap global constructors for prevent change them in library
                : IS_WRAP && target[key] == out ? (function (C) {
                    var F = function (a, b, c) {
                        if (this instanceof C) {
                            switch (arguments.length) {
                                case 0: return new C();
                                case 1: return new C(a);
                                case 2: return new C(a, b);
                            }
                            return new C(a, b, c);
                        }
                        return C.apply(this, arguments);
                    };
                    F[PROTOTYPE] = C[PROTOTYPE];
                    return F;
                    // make static versions for prototype methods
                })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key])
                hide(expProto, key, out);
        }
    }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(37)(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(105);
var toPrimitive = __webpack_require__(92);
var dP = Object.defineProperty;
exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE)
        try {
            return dP(O, P, Attributes);
        }
        catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes)
        throw TypeError('Accessors not supported!');
    if ('value' in Attributes)
        O[P] = Attributes.value;
    return O;
};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
    if (!isObject(it))
        throw TypeError(it + ' is not an object!');
    return it;
};


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(61);
module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined)
        return fn;
    switch (length) {
        case 1: return function (a) {
            return fn.call(that, a);
        };
        case 2: return function (a, b) {
            return fn.call(that, a, b);
        };
        case 3: return function (a, b, c) {
            return fn.call(that, a, b, c);
        };
    }
    return function ( /* ...args */) {
        return fn.apply(that, arguments);
    };
};


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = function (exec) {
    try {
        return !!exec();
    }
    catch (e) {
        return true;
    }
};


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(74);
var defined = __webpack_require__(70);
module.exports = function (it) {
    return IObject(defined(it));
};


/***/ }),

/***/ 41:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(62);
module.exports = __webpack_require__(23) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
    object[key] = value;
    return object;
};


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(70);
module.exports = function (it) {
    return Object(defined(it));
};


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(107);
var enumBugKeys = __webpack_require__(94);
module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

module.exports = function (it) {
    if (typeof it != 'function')
        throw TypeError(it + ' is not a function!');
    return it;
};


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

var toString = {}.toString;
module.exports = function (it) {
    return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 64:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(153), __esModule: true };


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _assign = __webpack_require__(65);
var _assign2 = _interopRequireDefault(_assign);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
    if (it == undefined)
        throw TypeError("Can't call method on  " + it);
    return it;
};


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(48);var _reactDom2=_interopRequireDefault(_reactDom);var _History=__webpack_require__(725);var _reactRouter=__webpack_require__(188);var _mobxReactRouter=__webpack_require__(726);var _mobxReact=__webpack_require__(8);var _weaWorkflowForm=__webpack_require__(727);var _weaWorkflowForm2=_interopRequireDefault(_weaWorkflowForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//umd
var routing=new _mobxReactRouter.RouterStore();var allStore=(0,_extends3.default)({routing:routing},_weaWorkflowForm2.default.store);var browserHistory=(0,_reactRouter.useRouterHistory)(_History.createHashHistory)({queryKey:'_key',basename:'/'});var history=(0,_mobxReactRouter.syncHistoryWithStore)(browserHistory,allStore.routing);window.weaWfFormHistory=history;var Home=function Home(props){return props.children;};var Root=function Root(){return _react2.default.createElement(_mobxReact.Provider,(0,_extends3.default)({ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Provider@9cmoye'},allStore),_react2.default.createElement(_reactRouter.Router,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Router@5z1bb7',history:history},_react2.default.createElement(_reactRouter.Route,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@yov1gh',breadcrumbName:'\u5355\u9875\u5165\u53E3',path:'/main',component:Home},_weaWorkflowForm2.default.Route)));};_reactDom2.default.render(_react2.default.createElement(Root,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Root@deflgb'}),document.getElementById('container'));

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_725__;

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
    if (true)
        module.exports = factory(__webpack_require__(9));
    else if (typeof define === 'function' && define.amd)
        define("MobxReactRouter", ["mobx"], factory);
    else if (typeof exports === 'object')
        exports["MobxReactRouter"] = factory(require("mobx"));
    else
        root["MobxReactRouter"] = factory(root["Mobx"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_0__) {
    return /******/ (function (modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId])
                /******/ return installedModules[moduleId].exports;
            /******/
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
                /******/ 
            };
            /******/
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/ 
        }
        /******/
        /******/
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/
        /******/ // identity function for calling harmory imports with the correct context
        /******/ __webpack_require__.i = function (value) { return value; };
        /******/
        /******/ // define getter function for harmory exports
        /******/ __webpack_require__.d = function (exports, name, getter) {
            /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
                /******/ 
            });
            /******/ 
        };
        /******/
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function (module) {
            /******/ var getter = module && module.__esModule ?
                /******/ function getDefault() { return module['default']; } :
                /******/ function getModuleExports() { return module; };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
            /******/ 
        };
        /******/
        /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 4);
        /******/ 
    })([
        /* 0 */
        /***/ function (module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
            /***/ 
        },
        /* 1 */
        /***/ function (module, exports, __webpack_require__) {
            "use strict";
            'use strict';
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _store = __webpack_require__(2);
            Object.keys(_store).forEach(function (key) {
                if (key === "default" || key === "__esModule")
                    return;
                Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: function get() {
                        return _store[key];
                    }
                });
            });
            var _sync = __webpack_require__(3);
            Object.keys(_sync).forEach(function (key) {
                if (key === "default" || key === "__esModule")
                    return;
                Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: function get() {
                        return _sync[key];
                    }
                });
            });
            /***/ 
        },
        /* 2 */
        /***/ function (module, exports, __webpack_require__) {
            "use strict";
            'use strict';
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.RouterStore = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _desc, _value, _class, _descriptor;
            var _mobx = __webpack_require__(0);
            function _initDefineProp(target, property, descriptor, context) {
                if (!descriptor)
                    return;
                Object.defineProperty(target, property, {
                    enumerable: descriptor.enumerable,
                    configurable: descriptor.configurable,
                    writable: descriptor.writable,
                    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
                });
            }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
                var desc = {};
                Object['ke' + 'ys'](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                });
                desc.enumerable = !!desc.enumerable;
                desc.configurable = !!desc.configurable;
                if ('value' in desc || desc.initializer) {
                    desc.writable = true;
                }
                desc = decorators.slice().reverse().reduce(function (desc, decorator) {
                    return decorator(target, property, desc) || desc;
                }, desc);
                if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                    desc.initializer = undefined;
                }
                if (desc.initializer === void 0) {
                    Object['define' + 'Property'](target, property, desc);
                    desc = null;
                }
                return desc;
            }
            function _initializerWarningHelper(descriptor, context) {
                throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
            }
            var RouterStore = exports.RouterStore = (_class = function () {
                function RouterStore() {
                    _classCallCheck(this, RouterStore);
                    _initDefineProp(this, 'location', _descriptor, this);
                    this.history = null;
                    this.push = this.push.bind(this);
                    this.replace = this.replace.bind(this);
                    this.go = this.go.bind(this);
                    this.goBack = this.goBack.bind(this);
                    this.goForward = this.goForward.bind(this);
                }
                _createClass(RouterStore, [{
                        key: '_updateLocation',
                        value: function _updateLocation(newState) {
                            this.location = newState;
                        }
                        /*
                         * History methods
                         */
                    }, {
                        key: 'push',
                        value: function push(location) {
                            this.history.push(location);
                        }
                    }, {
                        key: 'replace',
                        value: function replace(location) {
                            this.history.replace(location);
                        }
                    }, {
                        key: 'go',
                        value: function go(n) {
                            this.history.go(n);
                        }
                    }, {
                        key: 'goBack',
                        value: function goBack() {
                            this.history.goBack();
                        }
                    }, {
                        key: 'goForward',
                        value: function goForward() {
                            this.history.goForward();
                        }
                    }]);
                return RouterStore;
            }(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'location', [_mobx.observable], {
                enumerable: true,
                initializer: function initializer() {
                    return null;
                }
            }), _applyDecoratedDescriptor(_class.prototype, '_updateLocation', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, '_updateLocation'), _class.prototype)), _class);
            ;
            /***/ 
        },
        /* 3 */
        /***/ function (module, exports, __webpack_require__) {
            "use strict";
            'use strict';
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.syncHistoryWithStore = undefined;
            var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            } return target; };
            var _mobx = __webpack_require__(0);
            var syncHistoryWithStore = exports.syncHistoryWithStore = function syncHistoryWithStore(history, store) {
                // Initialise store
                store.history = history;
                // Handle update from history object
                var handleLocationChange = function handleLocationChange(location) {
                    store._updateLocation(location);
                };
                var unsubscribeFromHistory = history.listen(handleLocationChange);
                handleLocationChange(history.getCurrentLocation());
                return _extends({}, history, {
                    // User can subscribe to history changes
                    listen: function listen(listener) {
                        var onStoreChange = function onStoreChange(change) {
                            listener(store.location);
                        };
                        // Listen for changes to location state in store
                        var unsubscribeFromStore = (0, _mobx.observe)(store, 'location', onStoreChange);
                        listener(store.location);
                        return function () {
                            unsubscribeFromStore();
                        };
                    },
                    // Provide way to unsubscribe from history
                    unsubscribe: function unsubscribe() {
                        unsubscribeFromHistory();
                    }
                });
            };
            /***/ 
        },
        /* 4 */
        /***/ function (module, exports, __webpack_require__) {
            module.exports = __webpack_require__(1);
            /***/ 
        }
        /******/ 
    ]);
});
;



/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_727__;

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(63);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(73);
var min = Math.min;
module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(90)('keys');
var uid = __webpack_require__(71);
module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var global = __webpack_require__(20);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: core.version,
    mode: __webpack_require__(60) ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(20).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
    return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
    if (!isObject(it))
        return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf').split(',');


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index4single.js?v=63bc83c0